import {useUpdateEffect} from '@yandex-delivery/utils/hooks'
import React from 'react'
import type {RouteComponentProps} from 'react-router-dom'
import {config} from 'src/shared/config'

import type {RouterParams} from '../types'
import {CompleteScreen} from './components/screens'
import {SharedRoute} from './components/shared-route'
import {RouteSupportWidgetProvider} from './components/support-widget'

const HomePage: React.FC<RouteComponentProps<RouterParams>> = props => {
  const {location} = props
  const sharingKey = location.hash.substring(1)

  /**
   * Так как используется сейчас BrowserRoute вместо HashRouter, то при изменении хеша страница не перезагружается.
   * Поэтому, чтобы отследить изменение хеша, используется useUpdateEffect с зависимостью sharingKey.
   * Срабатывает только при обновлении. Первый рендер не учитывается.
   */
  useUpdateEffect(() => {
    window.location.reload()
  }, [sharingKey])

  return (
    <RouteSupportWidgetProvider
      country={config.country}
      debug={config.env === 'development' ? 'transport:xiva:push' : undefined}
      lang={config.lang}
      serviceID={config.messengerServiceID}
      simple={config.brand !== 'yandex'}
    >
      {sharingKey ? <SharedRoute sharingKey={sharingKey} /> : <CompleteScreen />}
    </RouteSupportWidgetProvider>
  )
}

HomePage.displayName = 'HomePage'

export {HomePage}
